import React from "react";
import { Link } from "react-router-dom";
import "./home.css";
import "../../styles/backgroundReveal.css";

const HomeDesktop = () => (
	<main
		className="home-page bg-reveal"
		data-bg={`${process.env.PUBLIC_URL}/backgrounds/background_home.png`}
	>
		<div className="home-card">
			<div className="home-content">
				<h1 className="home-title">Willkommen im FestivalPortal</h1>
				<p className="home-text">
					Bitte registriere dich oder melde dich an, um fortzufahren.
				</p>

				<div className="home-button-container">
					<Link to="/login" className="home-link">
						<button type="button" className="home-button">
							Login
						</button>
					</Link>

					<Link to="/register" className="home-link">
						<button type="button" className="home-button home-button-secondary">
							Registrieren
						</button>
					</Link>
				</div>
			</div>
		</div>
	</main>
);

export default HomeDesktop;